import React from "react";
import PdfViewer from "../../PdfViewer";

const DiseñoSolucionPropuestaTecnicoComercialRACI = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/04-diseño-de-solucion-y-propuesta-tecnico-comercial-RACI.pdf`;
  /*const pdfUrl = "/pdf/04-diseño-de-solucion-y-propuesta-tecnico-comercial-RACI.pdf";*/

  return (
    <>
      <main>
        <div class="titulo">
          <h1>Diseño de Solución y Propuesta Técnico-Comercial Matriz RACI</h1>
        </div>
        <div className="pdf-container">
          <PdfViewer pdfUrl={pdfUrl} />
        </div>
      </main>
    </>
  );
};

 export default DiseñoSolucionPropuestaTecnicoComercialRACI;
